<template>
	<BaseAuthUser v-slot="{isLoggedIn, urls, user, currentUrl}">
		<div v-if="isLoggedIn" class="auth-sidebar">
			<div class="auth-sidebar-top">
				<h2 class="a-dashboard-title"><BaseCmsLabel tag="span" code="hello" /> {{ user?.first_name }}</h2>
			</div>
			<ul class="auth-menu">
				<li>
					<NuxtLink :to="urls.auth" :class="['am-user', {'active': urls.auth == currentUrl}]"><BaseCmsLabel tag="span" code="my_profile" /></NuxtLink>
				</li>
				<li>
					<NuxtLink :to="urls.auth_my_webshoporder" :class="['am-orders', {'active': urls.auth_my_webshoporder == currentUrl}]"><BaseCmsLabel tag="span" code="my_orders" /></NuxtLink>
				</li>
				<li>
					<NuxtLink :to="urls.auth_my_webshopcoupon" :class="['am-coupon', {'active': urls.auth_my_webshopcoupon == currentUrl}]"><BaseCmsLabel tag="span" code="my_coupons" /></NuxtLink>
				</li>
				<li>
					<NuxtLink :to="urls.auth_my_comment" :class="['am-comment', {'active': urls.auth_my_comment == currentUrl}]"><BaseCmsLabel tag="span" code="my_webshop_comment" /></NuxtLink>
				</li>
				<li>
					<NuxtLink :to="urls.auth_edit" :class="['am-edit', {'active': urls.auth_edit == currentUrl}]"><BaseCmsLabel tag="span" code="edit_profile" /></NuxtLink>
				</li>
				<li>
					<NuxtLink :to="urls.auth_change_password" :class="['am-password', {'active': urls.auth_change_password == currentUrl}]"><BaseCmsLabel tag="span" code="change_password" /></NuxtLink>
				</li>
				<li>
					<NuxtLink :to="urls.auth_logout" class="am-logout"><BaseCmsLabel code="logout" tag="span" /></NuxtLink>
				</li>
			</ul>

			<div v-if="user?.loyalty_code && !mobileBreakpoint" class="auth-box-loyalty" :style="labelImage?.length ? { background: `url(${labelImage[0].url})` } : {}">
				<BaseCmsLabel code="auth_loyalty_sidebar_title" tag="div" class="auth-title-loyalty" />
				<div class="auth-loyalty-cnt">
					<BaseCmsLabel code="card_number" tag="span" class="label" /><span class="value">{{ user?.loyalty_code }}</span>
				</div>
				<div class="auth-loyalty-cnt">
					<BaseCmsLabel code="full_name" tag="span" class="label" /><span class="value">{{ user?.first_name }} {{ user?.last_name }}</span>
				</div>
			</div>
		</div>
	</BaseAuthUser>
</template>

<script setup>
	const labels = useLabels();

	//rwd
	const {mobileBreakpoint} = inject('rwd');

	const { extractImageUrls } = useImages();
	const labelImage = extractImageUrls(labels.get('dashboard_loyalty_sidebar_background'))
</script>

<style lang="less" scoped>
	.auth-sidebar{
		width: 400px; margin-right: 100px; flex-shrink: 0;

		@media (max-width: @l){width: 315px; margin-right: 70px;}
		@media (max-width: @t){width: 270px; margin-right: 35px;}
		@media (max-width: @m){width: calc(~"100% - -40px"); margin: 0 0 0 -20px; flex-shrink: unset; border-bottom: 1px solid #E0E8EE; position: relative;}
		@media (max-width: @ms){width: calc(~"100% - -30px"); margin-left: -15px; padding: 15px 15px 10px;}
	}
	.auth-sidebar-top{
		width: 100%; padding: 17px 25px; background: @blue;

		@media (max-width: @t){padding: 15px 20px;}
		@media (max-width: @m){padding: 20px; background: @white;}
		@media (max-width: @ms){padding: 0;}
	}
	.a-dashboard-title{
		font: 22px/1.4 @font; letter-spacing: -0.32px; color: @white; padding: 0;
		:deep(span){font-size: 16px; padding-bottom: 2px; display: block;}

		@media (max-width: @t){
			font-size: 18px;
			:deep(span){font-size: 14px;}
		}
		@media (max-width: @m){
			font-size: 28px; color: @textColor;
			:deep(span){font-size: 16px; padding-bottom: 3px;}
		}
		@media (max-width: @ms){
			font-size: 20px; line-height: 24px; display: none;
			:deep(span){font-size: 20px; line-height: 24px; display: inline-block;}
		}
	}
	.auth-menu{
		width: 100%; list-style: none; background: #F0F2F4;
		&>li{
			&>a{
				display: flex; align-items: center; font-size: 16px; line-height: 1.5; letter-spacing: -0.4px; text-decoration: none; color: @textColor; padding: 13px 22px; position: relative;
				&:before{.pseudo(10px,10px); background: #00B0DE; right: -5px; top: 52%; transform: translateY(-50%) rotate(45deg); opacity: 0;}
				&:hover{color: @blue;}
				&>span{
					position: relative; padding-left: 40px; display: flex; align-items: center;
					&:before{.icon-user(); font: 22px/22px @fonti; color: #4A7193; position: absolute; left: 0;}
				}
				&.active{
					background: linear-gradient(270deg, #00B0DE 0%, @blue 100%); color: @white;
					&:before{opacity: 1;}
					&>span:before{color: @white;}
				}
			}

			.am-user span:before{.icon-user(); left: 2px;}
			.am-orders span:before{.icon-cart();}
			.am-coupon span:before{.icon-coupon(); font: 17px/17px @fonti; left: 0;}
			.am-comment span:before{.icon-star-empty(); left: 1px;}
			.am-edit span:before{.icon-edit-pen(); left: 2px;}
			.am-password span:before{.icon-lock(); left: 4px;}
			.am-logout span:before{.icon-sign-out(); font: 19px/19px @fonti; left: -2px; left: 2px;}
		}

		@media (max-width: @t){
			&>li>a{
				font-size: 16px; padding: 13px 15px;
				&:hover{color: @textColor;}
				&.active{color: @white;}
			}
		}
		@media (max-width: @m){
			width: 100%; display: flex; flex-wrap: wrap; background: @white; position: relative; top: unset; left: unset; right: unset; border: none; padding: 0 20px 20px;
			&>li{
				width: calc(~"100% / 2"); padding: 0 10px 10px 0; max-width: unset; max-height: unset; height: auto; visibility: visible; opacity: 1;
				&>a{
					padding: 0; font-size: 12px;
					&>span{
						padding-left: 27px;
						&:before{.icon-user(); font: 16px/16px @fonti; color: #4A7193; position: absolute; left: 0;}
					}
					&.active{
						color: @blue; background: white;
						&:before{content: none;}
						span:before{color: #4A7193;}
					}
				}
				&.active{
					position: relative; top: unset; left: unset; right: unset; bottom: unset;
					&>a{
						padding: 0; background: @white; font-size: 12px; border: none; color: @blue;
						&:before{content: none;}
						span:before{color: #4A7193;}
					}
				}
				.am-user span:before{.icon-user(); left: 1px;}
				.am-orders span:before{.icon-cart();}
				.am-coupon span:before{.icon-coupon(); font: 11px/11px @fonti; left: 0;}
				.am-comment span:before{.icon-star-empty(); font: 14px/15px @fonti; left: 2px;}
				.am-edit span:before{.icon-edit-pen(); left: 2px;}
				.am-password span:before{.icon-lock(); font: 15px/15px @fonti; left: 4px;}
				.am-logout span:before{.icon-sign-out(); font: 13px/13px @fonti; left: 1px;}
			}
		}
		@media (max-width: @ms){padding: 20px 0 0;}
	}
</style>
